import { Injectable } from '@angular/core';
import { BaseApiCaller } from '../base-api-caller';
import { HttpClient } from '@angular/common/http';
import { DictionaryModel } from '../../models/dictionary-model';

@Injectable({
  providedIn: 'root'
})
export class EnduranceClassApiCallerService extends BaseApiCaller {
  protected controllerPath = 'enduranceClass';

  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  public getAll() {
    return this.get<DictionaryModel<string>[]>('');
  }
}
